import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Alert, Icon, Spin} from 'antd'
import UpdatePartner from './UpdatePartner'
import moment from 'moment'
import {TYPE_PARTNER} from "../../../helpers/typePartner"

class PartnerInfo extends Component {
    render() {
        const {id, loading, error, partner, onGetPartner} = this.props
        const typePartner = TYPE_PARTNER.find(item => item.value === partner.type_partner)

        return (
            <div className="PartnerInfo">
                {
                    error ?
                        <Alert message={error} type='error'/>
                        : <Spin spinning={loading} tip={'Đang lấy thông tin'}>
                            <div className="d-flex align-items-center">
                                <h3 className="name mr-2 mb-2">{partner.name}</h3>
                                {
                                    partner.hasOwnProperty('name') &&
                                    <UpdatePartner id={id} name={partner.name} onGetPartner={onGetPartner}/>
                                }
                            </div>

                            <div className='mb-1'>
                                <Icon type="code-sandbox" className='mr-2'/>
                                <strong className='mr-1'>Loại đối tác:</strong>
                                {typePartner !== undefined && typePartner.name}
                            </div>

                            <div>
                                <Icon type="schedule" className='mr-2'/>
                                <strong className='mr-1'>Ngày tạo:</strong>
                                {
                                    !partner.hasOwnProperty('updated_at') ?
                                        moment(partner.created_at).format('HH:mm DD/MM/YYYY')
                                        : moment(partner.updated_at).format('HH:mm DD/MM/YYYY')
                                }
                            </div>
                        </Spin>
                }
            </div>
        )
    }
}

PartnerInfo.propTypes = {
    id: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    error: PropTypes.string,
    partner: PropTypes.object,
    onGetPartner: PropTypes.func.isRequired
}

export default PartnerInfo